import axios from 'axios'
import { clearAuthSession, getStoredToken } from '@/utils/authStorage'

function redirectToLogin(reason = 'session_expired') {
  if (typeof window === 'undefined' || window.location.pathname === '/login') {
    return
  }

  const redirect = encodeURIComponent(window.location.pathname + window.location.search)
  const reasonParam = encodeURIComponent(reason)
  window.location.assign(`/login?redirect=${redirect}&reason=${reasonParam}`)
}

// Create axios instance with base configuration
const api = axios.create({
  baseURL: '',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    const token = getStoredToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    console.log('Making request to:', config.url)
    return config
  },
  (error) => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// Add response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('Response received:', response.status, response.config.url)
    return response
  },
  (error) => {
    const requestUrl = error.config?.url || ''
    const statusCode = error.response?.status || 0
    const isLoginEndpoint = /auth-login\.php$/.test(requestUrl)
    const isSessionEndpoint = /auth-session\.php$/.test(requestUrl)
    const isLogoutEndpoint = /auth-logout\.php$/.test(requestUrl)

    if (statusCode === 401 && isSessionEndpoint) {
      console.warn('Session expired while validating auth session:', requestUrl)
    } else {
      console.error('Response error:', error.message, requestUrl)
    }

    if (error.response) {
      if (!(statusCode === 401 && isSessionEndpoint)) {
        console.error('Error response:', error.response.status, error.response.data)
      }

      if (statusCode === 401 && !isLoginEndpoint) {
        clearAuthSession()
        if (!isLogoutEndpoint) {
          redirectToLogin('session_expired')
        }
      }
    } else if (error.request) {
      console.error('No response received:', error.request)
    }

    return Promise.reject(error)
  }
)

export default api
